"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _scene = require("../../utils/scene/scene");
var _SceneLayouts = require("../../constants/SceneLayouts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Create a scene where all presenters are rendered side by side.
 *
 * @param {Array} sources
 * @param {{}} sourceStyle
 */
function sideBySideBuilder(sources) {
  var sourceStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var TILE_BORDER = _scene.SCENE_WIDTH * 0.00595;
  var camSources = (0, _scene.getCameraSources)(sources);
  return {
    // TODO: remove as it is unnecessary and unused and probably will be confused w/ mongo object IDs
    _id: 'sceneSideBySide',
    title: _SceneLayouts.SIDE_BY_SIDE.title,
    description: _SceneLayouts.SIDE_BY_SIDE.title,
    style: _objectSpread({}, _scene.COMMON_SCENE_STYLES),
    layers: camSources.map(function (source, sourceIndex) {
      var camSourceCount = camSources.length;
      var tileHeight = _scene.SCENE_HEIGHT;
      var tileWidth = _scene.SCENE_WIDTH / camSourceCount;
      var borderLeft = sourceIndex ? TILE_BORDER : 0;
      var leftOffset = tileWidth * sourceIndex;
      var top = tileHeight - 80;
      return {
        _id: source._id,
        source: source,
        layer: {
          animation: _objectSpread(_objectSpread({}, _scene.HARD_CUT_ANIMATION), {}, {
            animate: _objectSpread(_objectSpread({}, _scene.HARD_CUT_ANIMATION.animate), {}, {
              top: 0,
              left: leftOffset,
              width: tileWidth,
              height: tileHeight
            })
          }),
          style: _objectSpread(_objectSpread(_objectSpread({}, _scene.COMMON_CAMERA_STYLES.styles), {}, {
            top: 0,
            left: leftOffset,
            width: tileWidth,
            height: tileHeight,
            zIndex: sourceIndex,
            position: 'absolute',
            borderLeft: "".concat(borderLeft, "px solid #000000"),
            mediaStyle: _objectSpread(_objectSpread({}, _scene.COMMON_CAMERA_STYLES.mediaStyles), {}, {
              objectFit: 'cover',
              height: tileHeight
            })
          }, sourceStyle), {}, {
            bannerStyles: _objectSpread({
              bottom: 0,
              maxWidth: tileWidth,
              zIndex: sourceIndex,
              position: 'absolute',
              left: leftOffset + (sourceIndex ? 11 : 0)
            }, _scene.extraPresenterBannerStyles),
            bannerAnimation: _objectSpread(_objectSpread({}, _scene.PRESENTER_BANNER_ANIMATION), {}, {
              animate: _objectSpread(_objectSpread({}, _scene.PRESENTER_BANNER_ANIMATION.animate), {}, {
                top: top,
                left: leftOffset + (sourceIndex ? 11 : 0)
              })
            })
          })
        }
      };
    })
  };
}
var _default = exports["default"] = sideBySideBuilder;